import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, IconButton, Skeleton, Stack, Typography, colors } from '@mui/material';
import parse, { DOMNode } from 'html-react-parser';
import { useSearchContext } from '../context';
import { Download } from '@mui/icons-material';
import { ContentPage } from '../styles';
import PolicyContentHelper from 'views/App/Portal/Policy/_helpers/policyContentHelper';

function IssuedManualsSearchPreface({
  manualId,
  preface,
  scrollId,
}: {
  manualId: string;
  preface?: any;
  scrollId?: string;
}) {
  const [params] = useSearchParams();
  const { handleDownload, isContentLoading } = useSearchContext();

  useEffect(() => {
    if (scrollId) {
      const element = document.getElementById(`preface_${scrollId}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [scrollId, isContentLoading]);

  return (
    <Stack>
      <ContentPage>
        <Stack spacing={10}>
          {isContentLoading ? (
            <Stack spacing={2}>
              <Skeleton
                variant='rectangular'
                height={28}
                width='50%'
              />
              <Stack>
                <Skeleton variant='text' />
                <Skeleton variant='text' />
                <Skeleton variant='text' />
              </Stack>
            </Stack>
          ) : (
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                {preface?.title && (
                  <Typography
                    variant='h4'
                    sx={{ mb: 3 }}
                  >
                    {preface.title}
                  </Typography>
                )}
                {manualId && preface?.id && (
                  <IconButton onClick={() => handleDownload(manualId, preface.id, 'PREFACE', preface?.title)}>
                    <Download />
                  </IconButton>
                )}
              </Box>

              <Stack
                id={`preface_${preface?.id}`}
                sx={{
                  backgroundColor: preface?.id.toString() === params.get('s') ? colors.amber[50] : 'transparent',
                }}
              >
                {parse(preface?.content || '', {
                  replace(node: DOMNode, ind: number) {
                    return PolicyContentHelper.handleContent(node, ind);
                  },
                })}
              </Stack>
            </>
          )}
        </Stack>
      </ContentPage>
    </Stack>
  );
}

export default IssuedManualsSearchPreface;
